/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GalleryIndexRouteImport } from './routes/gallery.index'
import { Route as FaqIndexRouteImport } from './routes/faq.index'
import { Route as DonateIndexRouteImport } from './routes/donate.index'
import { Route as ContactIndexRouteImport } from './routes/contact.index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as AppointmentIndexRouteImport } from './routes/appointment.index'
import { Route as AboutIndexRouteImport } from './routes/about.index'
import { Route as LocationIndexRouteImport } from './routes/$location/index'
import { Route as ServicesStiIndexRouteImport } from './routes/services/sti.index'
import { Route as ServicesPrepIndexRouteImport } from './routes/services/prep.index'
import { Route as ServicesPepIndexRouteImport } from './routes/services/pep.index'
import { Route as ServicesHivIndexRouteImport } from './routes/services/hiv.index'
import { Route as ServicesHepCIndexRouteImport } from './routes/services/hep-c.index'
import { Route as BlogUrlIndexRouteImport } from './routes/blog/$url.index'
import { Route as LocationGalleryIndexRouteImport } from './routes/$location/gallery.index'
import { Route as LocationAppointmentIndexRouteImport } from './routes/$location/appointment.index'
import { Route as AppointmentRescheduleIdIndexRouteImport } from './routes/appointment.reschedule.$id.index'
import { Route as LocationServicesStiIndexRouteImport } from './routes/$location/services/sti.index'
import { Route as LocationServicesPrepIndexRouteImport } from './routes/$location/services/prep.index'
import { Route as LocationServicesPepIndexRouteImport } from './routes/$location/services/pep.index'
import { Route as LocationServicesHivIndexRouteImport } from './routes/$location/services/hiv.index'
import { Route as LocationServicesHepCIndexRouteImport } from './routes/$location/services/hep-c.index'
import { ServerRoute as ResourcesSplatServerRouteImport } from './routes/resources.$'

const rootServerRouteImport = createServerRootRoute()

const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryIndexRoute = GalleryIndexRouteImport.update({
  id: '/gallery/',
  path: '/gallery/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqIndexRoute = FaqIndexRouteImport.update({
  id: '/faq/',
  path: '/faq/',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateIndexRoute = DonateIndexRouteImport.update({
  id: '/donate/',
  path: '/donate/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactIndexRoute = ContactIndexRouteImport.update({
  id: '/contact/',
  path: '/contact/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const AppointmentIndexRoute = AppointmentIndexRouteImport.update({
  id: '/appointment/',
  path: '/appointment/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutIndexRoute = AboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationIndexRoute = LocationIndexRouteImport.update({
  id: '/$location/',
  path: '/$location/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesStiIndexRoute = ServicesStiIndexRouteImport.update({
  id: '/services/sti/',
  path: '/services/sti/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesPrepIndexRoute = ServicesPrepIndexRouteImport.update({
  id: '/services/prep/',
  path: '/services/prep/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesPepIndexRoute = ServicesPepIndexRouteImport.update({
  id: '/services/pep/',
  path: '/services/pep/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesHivIndexRoute = ServicesHivIndexRouteImport.update({
  id: '/services/hiv/',
  path: '/services/hiv/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesHepCIndexRoute = ServicesHepCIndexRouteImport.update({
  id: '/services/hep-c/',
  path: '/services/hep-c/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogUrlIndexRoute = BlogUrlIndexRouteImport.update({
  id: '/$url/',
  path: '/$url/',
  getParentRoute: () => BlogRoute,
} as any)
const LocationGalleryIndexRoute = LocationGalleryIndexRouteImport.update({
  id: '/$location/gallery/',
  path: '/$location/gallery/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationAppointmentIndexRoute =
  LocationAppointmentIndexRouteImport.update({
    id: '/$location/appointment/',
    path: '/$location/appointment/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppointmentRescheduleIdIndexRoute =
  AppointmentRescheduleIdIndexRouteImport.update({
    id: '/appointment/reschedule/$id/',
    path: '/appointment/reschedule/$id/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LocationServicesStiIndexRoute =
  LocationServicesStiIndexRouteImport.update({
    id: '/$location/services/sti/',
    path: '/$location/services/sti/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LocationServicesPrepIndexRoute =
  LocationServicesPrepIndexRouteImport.update({
    id: '/$location/services/prep/',
    path: '/$location/services/prep/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LocationServicesPepIndexRoute =
  LocationServicesPepIndexRouteImport.update({
    id: '/$location/services/pep/',
    path: '/$location/services/pep/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LocationServicesHivIndexRoute =
  LocationServicesHivIndexRouteImport.update({
    id: '/$location/services/hiv/',
    path: '/$location/services/hiv/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LocationServicesHepCIndexRoute =
  LocationServicesHepCIndexRouteImport.update({
    id: '/$location/services/hep-c/',
    path: '/$location/services/hep-c/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ResourcesSplatServerRoute = ResourcesSplatServerRouteImport.update({
  id: '/resources/$',
  path: '/resources/$',
  getParentRoute: () => rootServerRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blog': typeof BlogRouteWithChildren
  '/$location': typeof LocationIndexRoute
  '/about': typeof AboutIndexRoute
  '/appointment': typeof AppointmentIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/contact': typeof ContactIndexRoute
  '/donate': typeof DonateIndexRoute
  '/faq': typeof FaqIndexRoute
  '/gallery': typeof GalleryIndexRoute
  '/$location/appointment': typeof LocationAppointmentIndexRoute
  '/$location/gallery': typeof LocationGalleryIndexRoute
  '/blog/$url': typeof BlogUrlIndexRoute
  '/services/hep-c': typeof ServicesHepCIndexRoute
  '/services/hiv': typeof ServicesHivIndexRoute
  '/services/pep': typeof ServicesPepIndexRoute
  '/services/prep': typeof ServicesPrepIndexRoute
  '/services/sti': typeof ServicesStiIndexRoute
  '/$location/services/hep-c': typeof LocationServicesHepCIndexRoute
  '/$location/services/hiv': typeof LocationServicesHivIndexRoute
  '/$location/services/pep': typeof LocationServicesPepIndexRoute
  '/$location/services/prep': typeof LocationServicesPrepIndexRoute
  '/$location/services/sti': typeof LocationServicesStiIndexRoute
  '/appointment/reschedule/$id': typeof AppointmentRescheduleIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$location': typeof LocationIndexRoute
  '/about': typeof AboutIndexRoute
  '/appointment': typeof AppointmentIndexRoute
  '/blog': typeof BlogIndexRoute
  '/contact': typeof ContactIndexRoute
  '/donate': typeof DonateIndexRoute
  '/faq': typeof FaqIndexRoute
  '/gallery': typeof GalleryIndexRoute
  '/$location/appointment': typeof LocationAppointmentIndexRoute
  '/$location/gallery': typeof LocationGalleryIndexRoute
  '/blog/$url': typeof BlogUrlIndexRoute
  '/services/hep-c': typeof ServicesHepCIndexRoute
  '/services/hiv': typeof ServicesHivIndexRoute
  '/services/pep': typeof ServicesPepIndexRoute
  '/services/prep': typeof ServicesPrepIndexRoute
  '/services/sti': typeof ServicesStiIndexRoute
  '/$location/services/hep-c': typeof LocationServicesHepCIndexRoute
  '/$location/services/hiv': typeof LocationServicesHivIndexRoute
  '/$location/services/pep': typeof LocationServicesPepIndexRoute
  '/$location/services/prep': typeof LocationServicesPrepIndexRoute
  '/$location/services/sti': typeof LocationServicesStiIndexRoute
  '/appointment/reschedule/$id': typeof AppointmentRescheduleIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blog': typeof BlogRouteWithChildren
  '/$location/': typeof LocationIndexRoute
  '/about/': typeof AboutIndexRoute
  '/appointment/': typeof AppointmentIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/contact/': typeof ContactIndexRoute
  '/donate/': typeof DonateIndexRoute
  '/faq/': typeof FaqIndexRoute
  '/gallery/': typeof GalleryIndexRoute
  '/$location/appointment/': typeof LocationAppointmentIndexRoute
  '/$location/gallery/': typeof LocationGalleryIndexRoute
  '/blog/$url/': typeof BlogUrlIndexRoute
  '/services/hep-c/': typeof ServicesHepCIndexRoute
  '/services/hiv/': typeof ServicesHivIndexRoute
  '/services/pep/': typeof ServicesPepIndexRoute
  '/services/prep/': typeof ServicesPrepIndexRoute
  '/services/sti/': typeof ServicesStiIndexRoute
  '/$location/services/hep-c/': typeof LocationServicesHepCIndexRoute
  '/$location/services/hiv/': typeof LocationServicesHivIndexRoute
  '/$location/services/pep/': typeof LocationServicesPepIndexRoute
  '/$location/services/prep/': typeof LocationServicesPrepIndexRoute
  '/$location/services/sti/': typeof LocationServicesStiIndexRoute
  '/appointment/reschedule/$id/': typeof AppointmentRescheduleIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blog'
    | '/$location'
    | '/about'
    | '/appointment'
    | '/blog/'
    | '/contact'
    | '/donate'
    | '/faq'
    | '/gallery'
    | '/$location/appointment'
    | '/$location/gallery'
    | '/blog/$url'
    | '/services/hep-c'
    | '/services/hiv'
    | '/services/pep'
    | '/services/prep'
    | '/services/sti'
    | '/$location/services/hep-c'
    | '/$location/services/hiv'
    | '/$location/services/pep'
    | '/$location/services/prep'
    | '/$location/services/sti'
    | '/appointment/reschedule/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$location'
    | '/about'
    | '/appointment'
    | '/blog'
    | '/contact'
    | '/donate'
    | '/faq'
    | '/gallery'
    | '/$location/appointment'
    | '/$location/gallery'
    | '/blog/$url'
    | '/services/hep-c'
    | '/services/hiv'
    | '/services/pep'
    | '/services/prep'
    | '/services/sti'
    | '/$location/services/hep-c'
    | '/$location/services/hiv'
    | '/$location/services/pep'
    | '/$location/services/prep'
    | '/$location/services/sti'
    | '/appointment/reschedule/$id'
  id:
    | '__root__'
    | '/'
    | '/blog'
    | '/$location/'
    | '/about/'
    | '/appointment/'
    | '/blog/'
    | '/contact/'
    | '/donate/'
    | '/faq/'
    | '/gallery/'
    | '/$location/appointment/'
    | '/$location/gallery/'
    | '/blog/$url/'
    | '/services/hep-c/'
    | '/services/hiv/'
    | '/services/pep/'
    | '/services/prep/'
    | '/services/sti/'
    | '/$location/services/hep-c/'
    | '/$location/services/hiv/'
    | '/$location/services/pep/'
    | '/$location/services/prep/'
    | '/$location/services/sti/'
    | '/appointment/reschedule/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlogRoute: typeof BlogRouteWithChildren
  LocationIndexRoute: typeof LocationIndexRoute
  AboutIndexRoute: typeof AboutIndexRoute
  AppointmentIndexRoute: typeof AppointmentIndexRoute
  ContactIndexRoute: typeof ContactIndexRoute
  DonateIndexRoute: typeof DonateIndexRoute
  FaqIndexRoute: typeof FaqIndexRoute
  GalleryIndexRoute: typeof GalleryIndexRoute
  LocationAppointmentIndexRoute: typeof LocationAppointmentIndexRoute
  LocationGalleryIndexRoute: typeof LocationGalleryIndexRoute
  ServicesHepCIndexRoute: typeof ServicesHepCIndexRoute
  ServicesHivIndexRoute: typeof ServicesHivIndexRoute
  ServicesPepIndexRoute: typeof ServicesPepIndexRoute
  ServicesPrepIndexRoute: typeof ServicesPrepIndexRoute
  ServicesStiIndexRoute: typeof ServicesStiIndexRoute
  LocationServicesHepCIndexRoute: typeof LocationServicesHepCIndexRoute
  LocationServicesHivIndexRoute: typeof LocationServicesHivIndexRoute
  LocationServicesPepIndexRoute: typeof LocationServicesPepIndexRoute
  LocationServicesPrepIndexRoute: typeof LocationServicesPrepIndexRoute
  LocationServicesStiIndexRoute: typeof LocationServicesStiIndexRoute
  AppointmentRescheduleIdIndexRoute: typeof AppointmentRescheduleIdIndexRoute
}
export interface FileServerRoutesByFullPath {
  '/resources/$': typeof ResourcesSplatServerRoute
}
export interface FileServerRoutesByTo {
  '/resources/$': typeof ResourcesSplatServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/resources/$': typeof ResourcesSplatServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths: '/resources/$'
  fileServerRoutesByTo: FileServerRoutesByTo
  to: '/resources/$'
  id: '__root__' | '/resources/$'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  ResourcesSplatServerRoute: typeof ResourcesSplatServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery/': {
      id: '/gallery/'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/': {
      id: '/faq/'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate/': {
      id: '/donate/'
      path: '/donate'
      fullPath: '/donate'
      preLoaderRoute: typeof DonateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact/': {
      id: '/contact/'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/appointment/': {
      id: '/appointment/'
      path: '/appointment'
      fullPath: '/appointment'
      preLoaderRoute: typeof AppointmentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about/': {
      id: '/about/'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location/': {
      id: '/$location/'
      path: '/$location'
      fullPath: '/$location'
      preLoaderRoute: typeof LocationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/sti/': {
      id: '/services/sti/'
      path: '/services/sti'
      fullPath: '/services/sti'
      preLoaderRoute: typeof ServicesStiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/prep/': {
      id: '/services/prep/'
      path: '/services/prep'
      fullPath: '/services/prep'
      preLoaderRoute: typeof ServicesPrepIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/pep/': {
      id: '/services/pep/'
      path: '/services/pep'
      fullPath: '/services/pep'
      preLoaderRoute: typeof ServicesPepIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/hiv/': {
      id: '/services/hiv/'
      path: '/services/hiv'
      fullPath: '/services/hiv'
      preLoaderRoute: typeof ServicesHivIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/hep-c/': {
      id: '/services/hep-c/'
      path: '/services/hep-c'
      fullPath: '/services/hep-c'
      preLoaderRoute: typeof ServicesHepCIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$url/': {
      id: '/blog/$url/'
      path: '/$url'
      fullPath: '/blog/$url'
      preLoaderRoute: typeof BlogUrlIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/$location/gallery/': {
      id: '/$location/gallery/'
      path: '/$location/gallery'
      fullPath: '/$location/gallery'
      preLoaderRoute: typeof LocationGalleryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location/appointment/': {
      id: '/$location/appointment/'
      path: '/$location/appointment'
      fullPath: '/$location/appointment'
      preLoaderRoute: typeof LocationAppointmentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointment/reschedule/$id/': {
      id: '/appointment/reschedule/$id/'
      path: '/appointment/reschedule/$id'
      fullPath: '/appointment/reschedule/$id'
      preLoaderRoute: typeof AppointmentRescheduleIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location/services/sti/': {
      id: '/$location/services/sti/'
      path: '/$location/services/sti'
      fullPath: '/$location/services/sti'
      preLoaderRoute: typeof LocationServicesStiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location/services/prep/': {
      id: '/$location/services/prep/'
      path: '/$location/services/prep'
      fullPath: '/$location/services/prep'
      preLoaderRoute: typeof LocationServicesPrepIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location/services/pep/': {
      id: '/$location/services/pep/'
      path: '/$location/services/pep'
      fullPath: '/$location/services/pep'
      preLoaderRoute: typeof LocationServicesPepIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location/services/hiv/': {
      id: '/$location/services/hiv/'
      path: '/$location/services/hiv'
      fullPath: '/$location/services/hiv'
      preLoaderRoute: typeof LocationServicesHivIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$location/services/hep-c/': {
      id: '/$location/services/hep-c/'
      path: '/$location/services/hep-c'
      fullPath: '/$location/services/hep-c'
      preLoaderRoute: typeof LocationServicesHepCIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/resources/$': {
      id: '/resources/$'
      path: '/resources/$'
      fullPath: '/resources/$'
      preLoaderRoute: typeof ResourcesSplatServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface BlogRouteChildren {
  BlogIndexRoute: typeof BlogIndexRoute
  BlogUrlIndexRoute: typeof BlogUrlIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogIndexRoute: BlogIndexRoute,
  BlogUrlIndexRoute: BlogUrlIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlogRoute: BlogRouteWithChildren,
  LocationIndexRoute: LocationIndexRoute,
  AboutIndexRoute: AboutIndexRoute,
  AppointmentIndexRoute: AppointmentIndexRoute,
  ContactIndexRoute: ContactIndexRoute,
  DonateIndexRoute: DonateIndexRoute,
  FaqIndexRoute: FaqIndexRoute,
  GalleryIndexRoute: GalleryIndexRoute,
  LocationAppointmentIndexRoute: LocationAppointmentIndexRoute,
  LocationGalleryIndexRoute: LocationGalleryIndexRoute,
  ServicesHepCIndexRoute: ServicesHepCIndexRoute,
  ServicesHivIndexRoute: ServicesHivIndexRoute,
  ServicesPepIndexRoute: ServicesPepIndexRoute,
  ServicesPrepIndexRoute: ServicesPrepIndexRoute,
  ServicesStiIndexRoute: ServicesStiIndexRoute,
  LocationServicesHepCIndexRoute: LocationServicesHepCIndexRoute,
  LocationServicesHivIndexRoute: LocationServicesHivIndexRoute,
  LocationServicesPepIndexRoute: LocationServicesPepIndexRoute,
  LocationServicesPrepIndexRoute: LocationServicesPrepIndexRoute,
  LocationServicesStiIndexRoute: LocationServicesStiIndexRoute,
  AppointmentRescheduleIdIndexRoute: AppointmentRescheduleIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  ResourcesSplatServerRoute: ResourcesSplatServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
